module.exports = __webpack_public_path__ + "media/src/images/dandori/step9-b99fb4fb33dd739ce35b25ab389622f4.png";